var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"grey lighten-2"},[_c('div',{staticClass:"flex-grow-1"}),_c('div',[_vm._v("© "+_vm._s(new Date().getFullYear()))]),_c('div',{staticClass:"pl-3"},[_vm._v("Kibuthi Allan")])])}
var staticRenderFns = []

export { render, staticRenderFns }